import Nav from 'components/layout/Nav';

const Header = (props) => {
    return (
        <div>
            <Nav />
        </div>
    );
};

export default Header;
